import * as React from "react";
const SvgFiRrMembershipVip = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 3H5C2.243 3 0 5.243 0 8v8c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V8c0-2.757-2.243-5-5-5m3 13c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-2-8a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1m-2 4a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1m-5.545-5.017a.75.75 0 0 1-.222.831l-1.774 1.445.734 2.235a.75.75 0 0 1-1.121.864l-2.065-1.345-2.031 1.359a.75.75 0 0 1-.867-.023.75.75 0 0 1-.266-.825l.706-2.262-1.783-1.451a.75.75 0 0 1 .485-1.321h2.251l.797-2.235a.75.75 0 0 1 1.406 0l.797 2.235h2.251a.75.75 0 0 1 .705.493z"
    />
  </svg>
);
export default SvgFiRrMembershipVip;
